import React, { useState } from "react";
import RestaurantPosForm from "../RestaurantPosForm/RestaurantPosForm";
import { IRestaurantPosFormData } from "../../../../../models/IRestaurantPosForm";
import callApi from "../../../../../utils/api-client";
import { useDispatch } from "react-redux";
import { constants } from "../../../../../common/constants/constants";
import { ToastNotification } from "../../../../../common/components/toastNotification/ToastNotification";
import successToast from "../../../../../assets/images/successToast.svg";
import errorToast from "../../../../../assets/images/errorToast.svg";
import { updateIsLoading } from "../../../../../reducerSlices/loaderSlice";
import { useNavigate } from "react-router-dom";
import { PosAcc } from "../../../../../types/pos";

function LinkRestaurantPos() {
  const [isLoading, setIsLoading] = useState(false);
  const [toastData, setToastData] = useState(constants.defaultToastData);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFormSubmit = async (data: IRestaurantPosFormData) => {
    setIsLoading(true);
    try {
      const posData: Omit<PosAcc, "id"> = {
        api_key: data.apiKey,
        secret_key: data.secretKey,
        pos_base_url: data.baseUrl,
        business_setup_id: data.business.id,
        retail_api_key: null,
        retail_secret_key: null,
        retail_pos_base_url: null,
        retail_pos_comapany_name: null,
      };
      // Simulate API call
      dispatch(updateIsLoading(true));
      await callApi<any>(
        "admin/pos/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(posData),
        },
        "linkRestaurantPos-createPOSLink"
      );

      setToastData({
        message: "POS linked successfully.",
        status: "Success",
      });
      dispatch(updateIsLoading(false));
      navigate("/admin/pos");
      return true;
    } catch (error) {
      console.error("Error saving configuration:", error);
      setToastData({
        message:
          error instanceof Error
            ? error.message
            : "Error saving configuration. Please try again.",
        status: "Fail",
      });
      return false;
    } finally {
      setTimeout(() => {
        setToastData(constants.defaultToastData);
      }, 10000);
      setIsLoading(false);
      dispatch(updateIsLoading(false));
    }
  };

  // Example initial data (optional)
  const initialFormData: IRestaurantPosFormData = {
    baseUrl: "",
    apiKey: "",
    secretKey: "",
    business: {
      id: "",
      name: "",
    },
    businessSearchName: "",
  };

  return (
    <div style={{ padding: "20px" }}>
      <RestaurantPosForm
        onSubmit={handleFormSubmit}
        initialData={initialFormData}
        isLoading={isLoading}
      />
      {toastData?.message && (
        <ToastNotification
          icon={toastData.status === "Success" ? successToast : errorToast}
          content={toastData?.message}
          position={"top-right"}
          autoClose={2000}
        />
      )}
    </div>
  );
}

export default LinkRestaurantPos;
